
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import Tabs from '@components/Tabs';
import ReactToPrint from 'react-to-print'
import Tours from './partials/tours'
import Transfers from './partials/transfers'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginTop: 15
  }
}))

// Feature "Revisão de vendas" (2026-08-17): mesmo relatório de comissão que
// já existe pra admin ver qualquer vendedor (SalesReserve.jsx), mas
// self-service — o próprio vendedor logado vê SÓ os próprios números, sem
// escolher um :id na URL. O type/id vêm do próprio usuário logado
// (typeable_type/typeable_id, já presentes no objeto retornado no login —
// ver LoginController). O backend (CommissionController::sales,
// SellerController::findSeller) IGNORA e substitui esses valores pelos do
// usuário autenticado quando o perfil não é administrador/gerente — então
// mesmo que o valor abaixo esteja errado por qualquer motivo, o back nunca
// deixa vazar dado de outro vendedor. Ver FEATURES.md seção "Comissões".
const typeableMap = {
  'App\\Models\\Seller': { type: 'seller', label: 'Vendedor' },
  'App\\Models\\PartnerSeller': { type: 'partner', label: 'Vendedor parceiro' },
  'App\\Models\\Agency': { type: 'agency', label: 'Agência parceira' },
}

const SelfReview = (props) => {
  const componentRef = useRef()
  const classes = useStyles()

  const typeableType = props?.user?.data?.typeable_type
  const id = props?.user?.data?.typeable_id
  const mapped = typeableMap[typeableType]

  const breadcrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin'
    },
    {
      title: 'Revisão de vendas',
    }
  ];

  if (!id || !mapped) {
    return <>
      <BreadCrumbs items={breadcrumbsConfig} />
      <div className="py-7 px-7 pt-6">
        <div className="text-2xl text-blue font-poppins mb-3">Revisão de vendas</div>
        <div className="p-4 bg-white border-1" style={{ borderRadius: '10px' }}>
          Seu usuário não está associado a um cadastro de vendedor. Fale com o
          administrador se acha que isso é um engano.
        </div>
      </div>
    </>
  }

  const { type } = mapped

  return <>
    {/* Fix (2026-08-19): mesmo fix de SalesReserve.jsx — força a tabela a caber
        na página impressa (evita cortar Comissão/Status no PC e tela em branco
        no celular depois da coluna "Desconto gerencial" nova). */}
    <style type="text/css" media="print">{`
      @page { size: landscape; margin: 5mm; }
      html, body { width: 100% !important; }
      .MuiTableContainer-root { width: 100% !important; max-width: 100% !important; overflow: visible !important; }
      .MuiTable-root, table { table-layout: fixed !important; width: 100% !important; max-width: 100% !important; }
      .MuiTableCell-root, table td, table th { overflow-wrap: break-word !important; word-break: break-word !important; white-space: normal !important; padding: 2px !important; font-size: 0.5rem !important; }
    `}</style>
    <BreadCrumbs items={breadcrumbsConfig} />
    <div className="py-7 px-7 pt-6">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue font-poppins">
        <span>Revisão de vendas</span>
        <ReactToPrint
          trigger={() => <Button
            textcolor="#fff"
            padding="6px 15px"
            margintop="0px"
            width="150px"
          >
            Baixar em PDF
          </Button>
          }
          content={() => componentRef.current}
        />
      </div>

      <Tabs
        ref={componentRef}
        className={classes.tabs}
        data={[
          {
            title: 'Passeios',
            content: (
              <Tours
                {...{
                  ...props,
                  type,
                  id,
                  sellerPrint: 'Revisão de vendas',
                  componentRef,
                  lockCurrentMonth: true,
                }}
              />
            )
          },
          type === 'seller' ?
          {
            title: 'Translados',
            content: (
              <Transfers
                {...{
                  ...props,
                  type,
                  id,
                  sellerPrint: 'Revisão de vendas',
                  componentRef,
                  lockCurrentMonth: true,
                }}
              />
            )
          } : ''
        ]}
      />
    </div>
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(SelfReview);
